import * as React from "react";
const AlertInformationLineIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 40 40",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20 8C13.373 8 8 13.373 8 20s5.373 12 12 12 12-5.373 12-12S26.627 8 20 8Zm7.028 19.028a9.94 9.94 0 1 1-14.056-14.056 9.94 9.94 0 1 1 14.056 14.056Zm-5.36-11.908a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.333 0Zm-.281 4.566v5.494a1.387 1.387 0 0 1-2.774 0v-5.494a1.387 1.387 0 1 1 2.774 0Z",
  clipRule: "evenodd"
}));
export default AlertInformationLineIcon;